<template>
  <div class="bg-white shadow rounded-4 p-3 p-lg-4">
    <div class="d-flex align-items-center border-bottom pb-4 mb-4">
      <div class="circle-avatar me-2 rounded-circle pulsate"></div>
      <div>
        <div class="block2 pulsate rounded-4"></div>
        <div class="block3 pulsate rounded-4"></div>
      </div>
    </div>
    <div class="border-bottom pb-4 mb-4 content">
      <div class="block4 pulsate rounded-4"></div>
      <div class="block5 pulsate rounded-4"></div>
    </div>

    <div class="d-flex justify-content-end">
      <div class="block1 pulsate me-3 rounded-4"></div>
      <div class="block6 pulsate rounded-4"></div>
    </div>
  </div>
</template>

<script>
export default {}
</script>

<style scoped lang="scss">
.content {
  min-height: 80px;
}
.block6 {
  width: 60%;
  height: 12px;
  margin-bottom: 8px;
}
.block1 {
  width: 78px;
  height: 12px;
  margin-bottom: 8px;
}
.block2 {
  width: 78px;
  height: 8px;
  margin-bottom: 8px;
}
.block3 {
  width: 131px;
  height: 8px;
  margin-bottom: 8px;
}
.block4 {
  width: 40%;
  height: 12px;
  margin-bottom: 16px;
}
.block5 {
  width: 67%;
  height: 12px;
  margin-bottom: 24px;
}

.pulsate {
  background: linear-gradient(-45deg, #dddddd, #f0f0f0, #dddddd, #f0f0f0);
  background-size: 400% 400%;
  -webkit-animation: Gradient 2.25s ease infinite;
  -moz-animation: Gradient 2.25s ease infinite;
  animation: Gradient 2.25s ease infinite;
}

.circle-avatar {
  width: 70px;
  height: 70px;
  object-fit: cover;

  @include media_mobile() {
    width: 40px;
    height: 40px;
  }
}

@-webkit-keyframes Gradient {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

@-moz-keyframes Gradient {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

@keyframes Gradient {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}
</style>
